<template>
  <path
    opacity="0.5"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13 2C12.4477 2 12 2.44771 12 3V10.8H10.1C9.49249 10.8 9 11.2925 9 11.9C9 12.5075 9.49249 13 10.1 13H12C13.1046 13 14 12.1046 14 11V3C14 2.44772 13.5523 2 13 2Z"
    fill="#3769D6"
  />
  <rect width="16" height="5" rx="2.5" fill="#3769D6" />
  <rect x="1" y="1" width="6" height="3" rx="1.5" fill="white" />
  <path
    d="M6.8418 14.8408L2.28114 10.2802"
    stroke="#3769D6"
    stroke-opacity="0.5"
    stroke-width="1.71993"
    stroke-linecap="round"
  />
  <path
    d="M2.28125 14.8408L6.84191 10.2802"
    stroke="#3769D6"
    stroke-width="1.71993"
    stroke-linecap="round"
  />
</template>
